module.exports = __webpack_public_path__ + "img/code.5006eaa6.jpg";